module.exports = __webpack_public_path__ + "static/media/tada_privacy_en_HK.df462b80.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/tada_privacy_en_HK.md
// module id = 91
// module chunks = 0